import React from 'react'
import { motion, AnimatePresence } from 'framer-motion';
import { MdPlayCircleOutline } from "react-icons/md";

const VideoPreview = ({landingPage,imageUrl,handleShowForm,bgColor,hoverColor,textColor}) => {
  
  return (
    <div>
      {/* Video Preview Section */}
      <motion.div 
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.5 }}
              className="relative group"
            >
              <div className="aspect-w-16 aspect-h-9 rounded-xl overflow-hidden shadow-2xl">
                <img
                  src={`${imageUrl}/${landingPage.image}`}
                  alt="Webinar Preview"
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent flex items-center justify-center">
                  <button 
                    onClick={handleShowForm}
                    className={`w-20 h-20 ${bgColor} bg-opacity-90 rounded-full flex items-center justify-center hover:${hoverColor} transition-all transform hover:scale-110`}
                  >
                    <MdPlayCircleOutline className="text-white text-4xl" />
                  </button>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 bg-white px-4 py-2 rounded-lg shadow-md">
                <p className={`text-sm font-semibold ${textColor}`}>Free Access</p>
              </div>
            </motion.div>
    </div>
  )
}

export default VideoPreview
